import { PATH } from 'constants/path';
import React from 'react';
import { Outlet } from 'react-router-dom';

// Mọi key auth được set lúc login (ElearningStudentLoginPage). Clear TẤT
// CẢ khi logout để không còn credential cũ nào sống sót qua một lần bounce.
const ELEARNING_AUTH_KEYS = [
  'sessionToken',
  'refreshToken',
  'moodleToken',
  'moodleSiteInfo',
  'forcePasswordChange',
  // Session-scoped keys khác — clear để KHÔNG rò rỉ sang HV kế tiếp trên
  // máy dùng chung (máy trường / quán net): chat RocketChat, cờ cap-block,
  // info trung tâm. Khớp danh sách logout ở App.js (devtools-logout).
  'rc-auth-token',
  'rc-user-id',
  'rc-username',
  'rc-channel-id',
  'elearning_limit_blocked',
  'center',
];

function logoutElearning() {
  try {
    ELEARNING_AUTH_KEYS.forEach((k) => localStorage.removeItem(k));
  } catch (_) { /* noop */ }
  window.location.href = PATH.ELEARNING.LOGIN;
}

function StudentElearningGuard() {
  // Phase 2D hoàn tất: sessionToken là credential DUY NHẤT được chấp nhận.
  // moodleToken đang bị chặn ở server-side, nên một tab chỉ còn moodleToken
  // (đã vô dụng) mà vẫn lọt qua check `||` cũ sẽ rơi vào các trang vỡ mà
  // không có lối thoát. Bắt buộc có sessionToken; nếu thiếu → tự động logout
  // (xoá sạch token cũ) để HV đăng nhập lại và nhận sessionToken mới.
  const sessionToken = localStorage.getItem('sessionToken');
  const forcePasswordChange = localStorage.getItem('forcePasswordChange');

  if (!sessionToken) {
    logoutElearning();
    return null;
  }

  if (forcePasswordChange === '1') {
    window.location.href = PATH.ELEARNING.CHANGE_PASSWORD;
    return null;
  }

  return <Outlet />;
}

export default StudentElearningGuard;
